import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { Localizations } from "../../../Shared/sharedTypes";

export default function orderReducer(
    state = initialState.localizations,
    action: CurrentMentorsActions
): Localizations | null {
    switch (action.type) {
        case types.UPDATE_CULTURE_SUCCESS:
        case types.LOAD_CURRENT_MENTORS_BY_ID_SUCCESS:
            return action.session.localizations as any;
        default:
            return state;
    }
}